import { LoginDao } from '../dao/LoginDao';

export class LoginBusiness {
  static async fetchKCLoginToken(data) {
    return LoginDao.fetchKCLoginToken(data);
  }

  static async fetchClientDomain(data) {
    return LoginDao.fetchClientDomain(data);
  }

  static async loginLionClient(clientUrl, dataForm) {
    return LoginDao.loginLionClient(clientUrl, dataForm);
  }

  static async verificarDominioAuth(data) {
    return LoginDao.verificarDominioAuth(data);
  }

  static async verificarDominio(data) {
    return LoginDao.verificarDominio(data);
  }

  static async obtenerTokenKeycloak(data) {
    return LoginDao.obtenerTokenKeycloak(data);
  }

  static async login(data) {
    return LoginDao.login(data);
  }

  static async sendEmailOTPCode() {
    return LoginDao.sendEmailOTPCode();
  }

  static async validateEmailOTPCode(data) {
    return LoginDao.validateEmailOTPCode(data);
  }

  static async getVersionTermsAndConditions() {
    return LoginDao.getVersionTermsAndConditions();
  }

  static async saveTermsAndConditions(version) {
    return LoginDao.saveTermsAndConditions(version);
  }

  static async obtenerCompaniasUsuario(data, text) {
    return LoginDao.obtenerCompaniasUsuario(data, text);
  }

  static async getTermsAndConditionsPDF() {
    return LoginDao.getTermsAndConditionsPDF();
  }
}
